import React from 'react';

import { BrandColor } from '@styleseat/brand';
import { Inline } from '@styleseat/ui';
import {
  CircleQuestionIcon,
  ReactionsHappyIcon,
  TimeCalendarCheckedIcon,
} from '../../ui/Icons';
import { BasicCutIcon } from '../../ui/Icons/BasicCutIcon';
import MonitoringGraphIcon from '../../ui/Icons/MonitoringGraphIcon';
import {
  BodyText,
  Separator,
  Stack,
} from '../../ui';
import { PROVIDER_ONBOARDING_SIGNUP } from '../../../route-names';
import TrackedOption from './TrackedOption';

interface SidebarProSectionProps {
  isProvider: boolean;
  linkTo: (url: string) => void;
  goToExternalPage: (url: string) => void;
}

const SidebarProSection: React.FC<SidebarProSectionProps> = ({
  isProvider,
  linkTo,
  goToExternalPage,
}) => (
  <Stack padding={20} space={16}>
    <BodyText appearance="larger" weight="bold">
      For Professionals
    </BodyText>
    <Separator color={BrandColor.LightGrey} appearance="extrathin" paddingTop={20} />
    {!isProvider && (
      <TrackedOption
        name="sidebar-set-up-my-business-clicked"
        testID="sidebar-set-up-my-business-option"
        onPress={() => linkTo(PROVIDER_ONBOARDING_SIGNUP)}
      >
        <Inline space={16}>
          <ReactionsHappyIcon width={20} height={20} />
          <BodyText weight="bold">
            Set up my business
          </BodyText>
        </Inline>
        <Separator color={BrandColor.LightGrey} appearance="extrathin" paddingTop={20} />
      </TrackedOption>
    )}
    <TrackedOption
      name="sidebar-how-to-get-started-clicked"
      testID="sidebar-how-to-get-started-option"
      onPress={() => goToExternalPage('join')}
    >
      <Inline space={16}>
        <CircleQuestionIcon width={20} height={20} />
        <BodyText>
          How to get started
        </BodyText>
      </Inline>
      <Separator color={BrandColor.LightGrey} appearance="extrathin" paddingTop={20} />
    </TrackedOption>
    <TrackedOption
      name="sidebar-grown-your-business-clicked"
      testID="sidebar-grown-your-business-option"
      onPress={() => goToExternalPage('join/grow-your-business')}
    >
      <Inline space={16}>
        <MonitoringGraphIcon width={20} height={20} />
        <BodyText>
          Grow your business
        </BodyText>
      </Inline>
      <Separator color={BrandColor.LightGrey} appearance="extrathin" paddingTop={20} />
    </TrackedOption>
    <TrackedOption
      name="sidebar-manage-your-business-clicked"
      testID="sidebar-manage-your-business-option"
      onPress={() => goToExternalPage('join/manage-your-business')}
    >
      <Inline space={16}>
        <TimeCalendarCheckedIcon width={20} height={20} />
        <BodyText>
          Manage your business
        </BodyText>
      </Inline>
      <Separator color={BrandColor.LightGrey} appearance="extrathin" paddingTop={20} />
    </TrackedOption>
    <TrackedOption
      name="sidebar-elevate-your-client-experience-clicked"
      testID="sidebar-elevate-your-client-experience-option"
      onPress={() => goToExternalPage('join/elevate-your-client-experience')}
    >
      <Inline space={16}>
        <BasicCutIcon width={20} height={20} />
        <BodyText>
          Elevate your client experience
        </BodyText>
      </Inline>
      <Separator color={BrandColor.LightGrey} appearance="extrathin" paddingTop={20} />
    </TrackedOption>
  </Stack>
);

export default SidebarProSection;
